import * as Sentry from "@sentry/vue";

const urls = process.env.SENTRY_PROJECT_NAME?.includes('-test') ? 
  ["https://www.bo.test.tokatab.com/play-api/v1/", "https://www.test.tokatab.com/", /https:\/\/(?!tokatab-assets\.onrender\.com)[^\s/]*onrender\.com[^\s]*/g, "https://localhost", "http://localhost"] :
  ["https://www.bo.alpha.tokatab.com/play-api/v1/", "https://www.app.tokatab.com/", "https://localhost", "http://localhost"]


export default ({ router, Vue }) => {
  const sentryInstance = Sentry.init({
    Vue,
    dsn: process.env.SENTRY_DSN,
    release: `${process.env.SENTRY_PROJECT_NAME}@${process.env.VERSION || 'dev'}`,
    dist: process.env.VERSION || 'dev',
    allowUrls: urls,
    integrations: [
      Sentry.browserTracingIntegration({ router }),
    ],
    // Tracing
    tracesSampleRate: 0.1,
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: urls,
    // Session Replay
    replaysSessionSampleRate: 0.0,
    replaysOnErrorSampleRate: 0.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    attachStacktrace: true
  });


  Vue.prototype.Monitoring = sentryInstance
}
